module.exports = __webpack_public_path__ + "src/assets/textures/tables/plane_table_mat1.png";